import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { LineChartData } from 'Molecules/InsightsChart/chartBuilder';
import { BaseInsightPayload } from '../InsightDataPayload';
import { InsightChartFactory } from '../insightChartFactory';
import { parseCapacityManagementResourceWorkloadOverviewPayload } from '../payloads/capacityManagementResourceWorkloadOverviewPayload';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';
import intl from 'react-intl-universal';

export const buildCapacityManagementResourceWorkloadOverviewInsightFactory = (
  payload: BaseInsightPayload
): InsightChartFactory => {
  const parsedPayload =
    parseCapacityManagementResourceWorkloadOverviewPayload(payload);
  const data = parsedPayload.data.attributes.data;

  return (props) => {
    const chart = new ChartBuilder()
      .setChartType(ChartType.LINE)
      .setProps({
        chartData: data as LineChartData,
        onDrillDown: props.onDrillDown,
        xAxisFieldName: 'date',
        yAxisFieldNames: ['capacity_hours', 'demand_hours', 'available_hours'],
        legendNames: [
          intl.get('INSIGHT.LEGEND.CAPACITY'),
          intl.get('INSIGHT.LEGEND.DEMAND'),
          intl.get('INSIGHT.LEGEND.AVAILABILITY'),
        ],
      })
      .build();

    return DefaultChartWithTrendSupport({
      chartComponent: chart,
    });
  };
};
